import _ from 'lodash';
import React from 'react';

import { Ref } from 'semantic-ui-react';

import Popup from '../Popup/Popup';

const CheckableDropdownPopup = (props) => {
    const {
        trigger,
        triggerStyle,
        ...rest
    } = props;

    // Largeur du trigger, à affecter à la Popup
    const [triggerWidth, setTriggerWidth] = React.useState(false);

    // Gère la ref du trigger pour obtenir la taille pour la Popup
    const handleRef = React.useCallback((node) => {
        const resizeObserver = new ResizeObserver((entries) => {
            _.map(entries, (entry) => {
                if (entry.contentRect) {
                    setTriggerWidth(entry.contentRect?.width);
                }
            });
        });

        if (!_.isNil(node)) {
            resizeObserver.observe(node);
        }
    }, []);

    return (
        <Popup
            {...rest}
            className='checkable-dropdown-popup'
            style={{
                width: triggerWidth,
                maxWidth: triggerWidth,
            }}
            // Première div obligé pour que la Popup réussise à mettre son event, sur la Ref ça marche pas
            // Deuxième div obligé pour avoir la bonne taille totale sans padding ni margin,
            // car la div.dropdown a un padding qui pose problème pour ResizeObserver
            trigger={(
                <div>
                    <Ref innerRef={handleRef}>
                        <div>
                            <div
                                className='ui multiple selection dropdown fluid checkable-dropdown'
                                style={triggerStyle}
                            >
                                {trigger}
                            </div>
                        </div>
                    </Ref>
                </div>
            )}
        />
    );
};

export default CheckableDropdownPopup;
